import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const BottomSheet = ({ isOpen, onClose, children }) => {
  const [isDraggingDisabled, setIsDraggingDisabled] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleEsc)

    if (isOpen) {
      document.body.style.overflow = 'hidden'
      setIsClosing(false) // 초기화
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      window.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target
    const atTop = scrollTop === 0
    const atBottom = scrollTop + clientHeight === scrollHeight

    if (!atTop && !atBottom) {
      setIsDraggingDisabled(true)
    } else {
      setIsDraggingDisabled(false)
    }
  }

  const handleDragEnd = (e, info) => {
    if (info.offset.y > 100) {
      setIsClosing(true)
      setTimeout(onClose, 300)
    }
  }

  return createPortal(
    <AnimatePresence>
      <div className="fixed inset-0 z-[10000] flex items-end justify-center">
        <motion.div
          onClick={onClose}
          className="fixed inset-0 bg-[#000] bg-opacity-80 z-[10000]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        />

        <motion.div
          className="bg-white rounded-t-lg w-full max-w-md shadow-lg max-h-[85vh] h-auto overflow-y-auto z-[10001]"
          initial={{ y: '100%' }}
          animate={{ y: isClosing ? '100%' : 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 35, stiffness: 300 }}
          drag={isDraggingDisabled ? false : 'y'}
          dragConstraints={{ top: 0, bottom: 0 }}
          dragElastic={0}
          onDragEnd={handleDragEnd}
          style={{ touchAction: 'pan-y' }}
        >
          <div className="sticky top-0 pt-8">
            <div className="mx-auto w-1/4 h-4 rounded bg-gray-300" />
            <div className="pb-24" />
          </div>
          <div
            className="overflow-y-auto max-h-[70vh] px-4 no-scrollbar"
            style={{ WebkitOverflowScrolling: 'touch' }}
            onScroll={handleScroll}
          >
            {children}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>,
    document.body
  )
}

export default BottomSheet
